export default {
	a_z: "A-Z",
	an_error_has_occurred_when_trying_to_redeem_the_item: "An error has occurred when trying to redeem the item",
	confirm_redeem: "Confirm the redemption",
	confirm_redeeming_the_item: "Confirm redemption of the item",
	departments: "Departments",
	error_redeeming_item: "An error occurred while redeeming the item",
	for: "for",
	insuficient_points_for_redeem: "Insuficient points for redemption",
	item_redeemed: "Item redeemed",
	no_rewards_found: "No rewards found",
	not_enough_items_in_stock: "Not enough items in stock",
	not_enough_points_to_redeem_item: "Not enough points to redeem the item",
	our_team_will_be_in_touch_for_the_next_steps: "You will receive a confirmation once it is approved.",
	popular: "Popular",
	price_bigger_to_smaller: " Price (high to low)",
	price_smaller_to_bigger: "Price (low to high)",
	redeem_now: "Redeem now",
	result_plural: "results",
	result: "result",
	search_for_rewards_here_to_redeem_with_your_points: "Welcome to the Intel Rewards You store! ",
	search_partners_or_offerings: "Search for partners or offers",
	you_have_reached_the_max_number_of_redemptions_for_this_category: "You have reached the maximum number of redemptions for this category.",
	you_redeemed_successfully_the_item: "Redemption identified: "
}